var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 12H8.625C7.59119 12 6.75 12.8408 6.75 13.875C6.75 14.9092 7.59119 15.75 8.625 15.75H15.375C16.4092 15.75 17.25 14.9092 17.25 13.875C17.25 12.8408 16.4092 12 15.375 12ZM9.375 15C8.75464 15 8.25 14.4954 8.25 13.875C8.25 13.2546 8.75464 12.75 9.375 12.75C9.99536 12.75 10.5 13.2546 10.5 13.875C10.5 14.4954 9.99536 15 9.375 15ZM14.625 15C14.0046 15 13.5 14.4954 13.5 13.875C13.5 13.2546 14.0046 12.75 14.625 12.75C15.2454 12.75 15.75 13.2546 15.75 13.875C15.75 14.4954 15.2454 15 14.625 15ZM21.75 12.8191V6.68092C22.1856 6.5256 22.5 6.11325 22.5 5.625C22.5 5.00464 21.9954 4.5 21.375 4.5C20.7546 4.5 20.25 5.00464 20.25 5.625C20.25 6.11325 20.5644 6.5256 21 6.68092V12.8191C20.8463 12.8739 20.707 12.9581 20.5922 13.0697C19.4489 9.41185 16.0298 6.75 12 6.75C7.97049 6.75 4.55122 9.4119 3.40782 13.0697C3.29306 12.9581 3.15372 12.8739 3 12.8191V6.68092C3.43556 6.5256 3.75 6.11325 3.75 5.625C3.75 5.00464 3.24536 4.5 2.625 4.5C2.00464 4.5 1.5 5.00464 1.5 5.625C1.5 6.11325 1.81444 6.5256 2.25 6.68092V12.8191C1.81444 12.9744 1.5 13.3867 1.5 13.875V16.875C1.5 17.4954 2.00464 18 2.625 18C2.97807 18 3.28976 17.8332 3.49617 17.578C4.14001 18.7189 5.34933 19.5 6.75 19.5H17.25C18.6507 19.5 19.86 18.7189 20.5038 17.578C20.7102 17.8332 21.0219 18 21.375 18C21.9954 18 22.5 17.4954 22.5 16.875V13.875C22.5 13.3867 22.1856 12.9744 21.75 12.8191ZM15.375 16.5H8.625C7.17773 16.5 6 15.3223 6 13.875C6 12.4277 7.17773 11.25 8.625 11.25H15.375C16.8223 11.25 18 12.4277 18 13.875C18 15.3223 16.8223 16.5 15.375 16.5Z",
    fill: "url(#paint0_linear_3204_249497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3204_249497",
    x1: 1.5,
    y1: 12.0005,
    x2: 22.5,
    y2: 12.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBot);
export default __webpack_public_path__ + "static/media/User_Bot.195f958e8a5f982e856f7858e276c649.svg";
export { ForwardRef as ReactComponent };